import type { ConversationTranscriptMessage } from '@/types/api';
import { CollapsibleContent } from '@/components/ui/collapsible';
import { ScrollArea } from '@/components/ui/scroll-area';
import { cn } from '@/components/ui/utils';

export interface ConversationTranscriptProps {
  transcript: ConversationTranscriptMessage[];
}

export const ConversationTranscript = ({
  transcript,
}: ConversationTranscriptProps) => {
  if (!transcript.length) return null;

  return (
    <CollapsibleContent className='mt-2'>
      <ScrollArea className='h-64 pr-2'>
        <div className='space-y-3 text-sm'>
          {transcript.map((msg, idx) => {
            const isAssistant = msg.role === 'assistant';
            const bubbleStyles = cn(
              'inline-flex max-w-[80%] flex-col rounded-lg border px-3 py-2 shadow-sm',
              isAssistant
                ? 'bg-primary/10 border-primary/40 text-primary'
                : 'bg-muted border-muted-foreground/30'
            );

            return (
              <div
                key={`${msg.role}-${idx}`}
                className={cn(
                  'flex w-full flex-col',
                  isAssistant ? 'items-end text-right' : 'items-start text-left'
                )}
              >
                <span className='text-[10px] font-semibold uppercase tracking-wide text-muted-foreground'>
                  {msg.role}
                </span>
                <span
                  className={cn(
                    'mt-1 leading-relaxed text-foreground',
                    bubbleStyles
                  )}
                >
                  {msg.content}
                </span>
              </div>
            );
          })}
        </div>
      </ScrollArea>
    </CollapsibleContent>
  );
};
